<template>
  <div class="no-results-main">
    <h1>{{ title }}</h1>
    <p>{{ text }}</p>
  </div>
</template>

<style lang="scss" scoped>
  .no-results-main {
    display:                   flex;
    flex:                      1;
    flex-direction:            column;
    align-items:               center;
    justify-content:           center;
    height:                    100%;

    h1,
    p {
      color:                   var(--Brand-Primary);
    }

    h1 {
      font-size:               38px;
      font-weight:             300;
      line-height:             normal;
    }

    p {
      font-size:               var(--font-size-14);
      font-weight:             400;
      line-height:             140%; /* 19.6px */
    }
  }
</style>

<script>
export default {
  name: 'BaseNoResults',
  props: ['title', 'text']
}
</script>
